import request from '@/utils/request'

export function getOpenid(code) {
  const wechatName = process.env.WECHAT_NAME;
  if(wechatName==='yff'){
    return request({
      url: '/WxAuth/getOpenId/'+code,
      method: 'post'
    })
  }else if(wechatName==='x16'){
    return request({
      url: '/x16WxAuth/getOpenId/'+code,
      method: 'post'
    })
  }

}

export function getInfo() {
  return request({
    url: '/index/getInfos',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

export function bindPhone(params) {
  return request({
    url: '/user/bindPhone',
    method: 'post',
    params: params
  })
}

export function moPanLogin(params) {
  return request({
    url: '/login/moPanLogin',
    method: 'post',
    params: params
  })
}

export function xiaoYiLogin(params) {
  return request({
    url: "/login/xiaoYiLogin",
    method: "post",
    params: params
  });
}

export function heJiaLogin(params) {
  return request({
    url: "/login/heJiaLogin",
    method: "post",
    params: params
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js